import React from 'react';
import PropTypes from 'prop-types';

import ActiveState from './ActiveState';

import CircularProgress from '@mui/material/CircularProgress';
import SaveIcon from '@mui/icons-material/Save';

import Button from 'ui/Button';

const Footer = ({reward, loading, published, mysteryBox, onChange}) => {

  return <div className={`new-form-field-footer`}>
    {loading ?
      <CircularProgress color="warning" />
      :
      <Button minwidth loading={loading} disabled={published} icon={SaveIcon}>
        {!reward.id ? 'Create' : 'Save'}
      </Button>
    }
    {!mysteryBox &&
      <ActiveState
        active_state={reward.active_state}
        onchange={onChange} />}
  </div>;
};

Footer.propTypes = {
  loading: PropTypes.bool,
  published: PropTypes.bool,
  record: PropTypes.object,
  mysteryBox: PropTypes.bool,
  reward: PropTypes.object,
  onChange: PropTypes.func
};

export default Footer;
